export const POSTS = "POSTS";
export const POSTS_LOAD_MORE = "POSTS_LOAD_MORE";
export const POSTS_LOAD_MORE_LOADING = "POSTS_LOAD_MORE_LOADING";
export const POST = "POST";
export const POST_LOADED = "POST_LOADED";
export const POSTS_RECENT = "POSTS_RECENT";
